import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class SessionService {

    public storageSub$: Subject<any> = new Subject<any>();
    public itemsObservable$ = this.storageSub$.asObservable();


    onSetItemJSON(key: string, value: any) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    onGeItemJSON(key: string) {
        return JSON.parse(sessionStorage.getItem(key));
    }

    onSetItem(key: string, value: any) {
        sessionStorage.setItem(key, value);
    }

    onGeItem(key: string) {
        return sessionStorage.getItem(key);
    }

    onExistItem(key: string) {
        if (sessionStorage.getItem(key)) {
            return true;
        } else {
            return false;
        }
    }

    onRemoveItem(key: string) {
        sessionStorage.removeItem(key);
    }

    onRemoveSession() {
        sessionStorage.clear();
    }

    watchStorage(): Observable<any> {
        return this.storageSub$.asObservable();
    }

    onCallStorage() {
        this.storageSub$.next('change');
    }

}
